import "./AdminLayout.css";
import { Routes, Route } from "react-router-dom";
import { signOut } from "aws-amplify/auth";

import Sidebar from "./Sidebar";

// PAGES
import AdminHome from "../AdminHome";
import UploadCSV from "../UploadCSV";
import EnterManual from "../EnterManual";
import ViewPage from "../ViewPage";
import Recents from "../Recents";
import EditPage from "../EditPage";
import DownloadPage from "../DownloadPage";
import DeleteOrders from "../DeleteOrders";


// SESSION TIMEOUT HOOK
import useSessionTimeout from "../../hooks/useSessionTimeout";

export default function AdminLayout() {
  // Current Date (top-right)
  const today = new Date().toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  // Logout action
  const logout = async () => {
    await signOut();
    window.location.href = "/admin/login";
  };

  //  Session timeout hook (with countdown)
  const { showWarning, countdown, stayLoggedIn } = useSessionTimeout();

  return (
    <div className="layout">

      {/* ---------- SESSION TIMEOUT MODAL ---------- */}
      {showWarning && (
       <div className="session-modal">
  <div className="session-modal-content">

    <div className="session-modal-header">
      <h3>Session Expiring</h3>
      <p>You have been inactive. Your session will end in <strong>{countdown}</strong> seconds.</p>
    </div>

    <div className="session-modal-actions-vertical">
  <button className="stay-btn" onClick={stayLoggedIn}>Keep Session</button>
  <button className="logout-btn-modal" onClick={logout}>End Session</button>
</div>


  </div>
</div>

      )}

      {/* ---------- SIDEBAR ---------- */}
      <Sidebar />

      {/* ---------- MAIN AREA ---------- */}
      <div className="main">

        {/* TOP-RIGHT: Date + Logout */}
        <div className="admin-top-right">
          <span className="admin-date">{today}</span>
          <button className="logout-btn" onClick={logout}>
            Logout
          </button>
        </div>

        {/* ---------- ROUTING ---------- */}
        <div className="content">
          <Routes>

            {/* DEFAULT ADMIN PAGE */}
            <Route index element={<AdminHome />} />

            {/* OTHER ADMIN ROUTES */}
            <Route path="upload" element={<UploadCSV />} />
            <Route path="manual" element={<EnterManual />} />
            <Route path="view" element={<ViewPage />} />
            <Route path="recents" element={<Recents />} />
            <Route path="edit" element={<EditPage />} />
            <Route path="download" element={<DownloadPage />} />
            <Route path="delete-orders" element={<DeleteOrders />} />


            

          </Routes>
        </div>

      </div>

    </div>
  );
}
